export default "__VITE_ASSET__eb818606__"